import { Component, OnInit } from '@angular/core';
import { LabeledProductService } from '../../services/labeledproduct.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryService } from '../../../common/services/category.service';
import { LabeledProductShopStockService } from '../../services/labeledproductshopstock.service';
import { Observable } from 'rxjs/Observable';
import { DistributorService } from '../../../distributors/services/distributor.service';

import * as JsBarcode from 'jsbarcode';
import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
declare let alasql;

@Component({
  selector: 'app-list-labeledproduct-report',
  templateUrl: './list-labeledproduct-report.component.html',
  styleUrls: ['./list-labeledproduct-report.component.css'],
  providers:[LabeledProductService,CategoryService,DistributorService,LabeledProductShopStockService]
})
export class ListLabeledProductReportComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  labeledProducts: any = [];
  filters:any = {
    barcode:{contains: ""},
    description:{contains: ""},
    storage_capacity: {contains: ""},
    status:{contains: ""},
    name:{contains: ""},
    short_description:{contains: ""},
    manufacturer_barcode:{contains: ""},
    provider_nif:{contains: ""},
    imei1:{contains: ""},
    imei2:{contains: ""},
    serial_number:{contains: ""}
  };
  onlyEditStock: boolean = false;
  onlyWithoutCategory: boolean = false;
  onlyWithoutCosts: boolean = false;
  onlyWithStock: boolean = false;
  onlySold: boolean = false;
  exportParams:any = {};
  showExportButton:boolean = true;
  selectedImage: any = null;
  selectedlabeledProduct: any = null;
  filteredDistributors: any = [];
  selectedDistributor: string = "";
  distributors: any = [];
  config: any = {'sourceField': ['name']};
  role:number = 3;

  constructor(private labeledProductService: LabeledProductService, private route: ActivatedRoute, private router: Router,private categoryService:CategoryService,
    private distributorService:DistributorService, private labeledProductShopStockService:LabeledProductShopStockService) { }

  ngOnInit() {
    if (this.route.url['_value'][1].path.includes("listtoeditstock")){
      this.onlyEditStock = true;
    }
    this.getLabeledProducts();
    this.getDistributors();
    setTimeout(function (){
      document.getElementById("barcode-filter").focus();
    },100);
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  getNameProductType(type){
    var productType= ["Móviles y Tablets","Consolas","Artículos Varios","PC's-portátiles"];
    return productType[type-1];
  }

  getDistributor(value){
    if (value.id){
      this.filters.distributor = value.name;
    }else{
      delete this.filters.distributor;
    }
    this.get();
  }

  filterDistributors(value){
    this.selectedDistributor = value;
    this.filteredDistributors = _.filter(this.distributors, function(o) { return o.name.toLowerCase().includes(value.toLowerCase()); });
    if (value == ""){
      delete this.filters.distributor;
      this.get();
    }
  }

  getDistributors(){
    this.distributorService.query({})
    .subscribe((distributors) => {
        this.distributors = distributors;
        this.filteredDistributors = distributors;
    }); 
  }
  
  get(){
    if (this.onlyWithoutCategory){
      this.getLabeledProductsWithoutCategories();
    }else{
      if (this.onlyWithoutCosts){
        this.filters.or = [
          {shipping_cost_tenerife: null},
          {shipping_cost_canary_island: null},
          {shipping_cost_mainland: null}
        ]
      }else{
        delete this.filters.or;
      }
      if (this.onlyWithStock){
        this.filters.stock = {
          '>' : 0
        }
      }else{
        delete this.filters.stock
      }
      if (this.onlySold){
        this.filters.sale_date = {
          '<=': moment().format("YYYY-MM-DD")
        }
      }else{
        delete this.filters.sale_date
      }
      this.getLabeledProducts();
    }
  }
  
  
  getLabeledProducts(){
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    this.exportParams = params;
    this.labeledProductService.queryWithExtraInfo(params)
      .subscribe((labeledProducts) => {
          this.labeledProducts = labeledProducts;
          labeledProducts.forEach((labeledProduct)=>{
            this.getProductPhotos(labeledProduct);
          });
          let countParams = {
            where: _.cloneDeep(params.where),
          };
          this.labeledProductService.countWithExtraInfo(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
            if (this.totalItems == 1 && this.onlyEditStock){
              this.router.navigate(['/labeledproduct/editStock/'+labeledProducts[0].id])
            }
          });
      });
  }

  getLabeledProductsWithoutCategories(){
    var params = {
      skip: (this.p-1)*10,
      limit: 10
    };
    this.labeledProductService.getLabeledProductsWithoutCategories(params)
      .subscribe((labeledProducts) => {
          this.labeledProducts = labeledProducts;
          this.labeledProductService.getCountLabeledProductsWithoutCategories({})
          .subscribe((count) => {
            this.totalItems = count[0].total;
          });
          labeledProducts.forEach((labeledProduct)=>{
            this.getProductPhotos(labeledProduct);
          });
      });
  }


  getProductPhotos(labeledProduct){
    this.labeledProductService.getProductPhotos(labeledProduct.id)
    .subscribe((result) => {
      labeledProduct.image = result[0].image;
    })
  }

  getLabeledProductStock(labeledProduct){
    let params = {
      labeledproduct: labeledProduct.id
    }
    this.labeledProductShopStockService.query(params).subscribe((labeledProductShopStocks) => {
      var result = "Stock por Tienda: \n";
      labeledProductShopStocks.forEach((e)=>{
        result+="-"+e.shop.name+": "+e.stock+"\n";
      })
      alert(result);
    });
  }

  exportLabeledProductsToExcel(){
    this.showExportButton = false;
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };             
    let report = [
          {
              field1:"Código de barras",
              field2:"Nombre",
              field3:"Descripción corta",
              field4:"Descripción",
              field5:"Categoría",
              field6:"Familia",
              field7:"Subfamilia",
              field8:"Stock",
              field9:"Precio de compra",
              field10:"Usurio que compra",
              field11:"Precio de venta",
              field12:"Fecha de etiquetado",
              field13:"Usuario que etiqueta",
              field14:"Fecha de venta",
              field15:"Usuario que vende",
              field16:"Costes de envío a Tenerife",
              field17:"Costes de envío a Canarias",
              field18:"Costes de envío a Península",
              field19:"Proveedor de consigna",
              field20:"Distribuidor",
              
          }
      ]
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      let observableLabeledProductsRequest = [];
      let request = Math.ceil(this.totalItems / 100);
      for (let i=0; i<request;i++){
        this.exportParams.skip = ((i)*100),
        this.exportParams.limit = 100
        // this.exportParams.skip = ((i-1)*100)+86,
        // this.exportParams.limit = 1
        if (this.onlyWithoutCategory){
          observableLabeledProductsRequest.push(this.labeledProductService.getLabeledProductsWithoutCategories(this.exportParams));
        }else{
          observableLabeledProductsRequest.push(this.labeledProductService.queryWithExtraInfo(this.exportParams));
        }
      }
      Observable.forkJoin(observableLabeledProductsRequest)
          .subscribe(data => {
            let p:any = data;
            let labeledProducts = p.flat(); 
                labeledProducts.forEach(labeledproduct =>{
                  if (labeledproduct.short_description){
                    labeledproduct.short_description = labeledproduct.short_description.replace(/</g, '');
                    labeledproduct.short_description = labeledproduct.short_description.replace(/>/g, '');
                    labeledproduct.short_description = labeledproduct.short_description.replace(/;/g, '');
                    labeledproduct.short_description = labeledproduct.short_description.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
                  }
                  if (labeledproduct.description){
                    labeledproduct.description = labeledproduct.description.replace(/</g, '');
                    labeledproduct.description = labeledproduct.description.replace(/>/g, '');
                    labeledproduct.description = labeledproduct.description.replace(/;/g, '');
                    labeledproduct.description = labeledproduct.description.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
                  }
                  if (labeledproduct.name){
                    labeledproduct.name = labeledproduct.name.replace(/</g, '');
                    labeledproduct.name = labeledproduct.name.replace(/>/g, '');
                    labeledproduct.name = labeledproduct.name.replace(/;/g, '');
                    labeledproduct.name = labeledproduct.name.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
                  }
                  var row = {
                      field1:labeledproduct.barcode?labeledproduct.barcode:"",
                      field2:labeledproduct.name?labeledproduct.name:"",
                      field3:labeledproduct.short_description?labeledproduct.short_description:"",
                      field4:labeledproduct.description?labeledproduct.description:"",
                      field5:labeledproduct.category?labeledproduct.category:"",
                      field6:labeledproduct.family?labeledproduct.family:"",
                      field7:labeledproduct.subfamily?labeledproduct.subfamily:"",
                      field8:labeledproduct.stock?labeledproduct.stock:"",
                      field9:labeledproduct.purchase_price?labeledproduct.purchase_price:"",
                      field10:labeledproduct.purchase_user?labeledproduct.purchase_user:"",
                      field11:labeledproduct.sale_price?labeledproduct.sale_price:"",
                      field12:labeledproduct.labeled_date?moment(labeledproduct.labeled_date).format("DD-MM-YYYY"):"",
                      field13:labeledproduct.label_user?labeledproduct.label_user:"",
                      field14:labeledproduct.sale_date?moment(labeledproduct.sale_date).format("DD-MM-YYYY"):"",
                      field15:labeledproduct.sale_user?labeledproduct.sale_user:"",
                      field16:labeledproduct.shipping_cost_tenerife?labeledproduct.shipping_cost_tenerife:"",
                      field17:labeledproduct.shipping_cost_canary_island?labeledproduct.shipping_cost_canary_island:"",
                      field18:labeledproduct.shipping_cost_mainland?labeledproduct.shipping_cost_mainland:"",
                      field19:labeledproduct.provider_nif?(labeledproduct.provider_name+ " "+labeledproduct.provider_surname+" "+labeledproduct.provider_nif ):"",
                      field20:labeledproduct.distributor?labeledproduct.distributor:"",
                  }
                  report.push(row);
              });
              var mystyle = {   
                  headers:true,       
                  columns:    
                      [{columnid:'field1',width:100,title: ''},   
                      {columnid:'field2',width:100,title: ''},
                      {columnid:'field3',width:100,title: 'LISTADO DE PRODUCTOS ETIQUETADOS'},
                      {columnid:'field4',width:300,title: ''},
                      {columnid:'field5',width:100,title: ''},
                      {columnid:'field6',width:100,title: ''},
                      {columnid:'field7',width:100,title: ''},
                      {columnid:'field8',width:100,title: ''}, 
                      {columnid:'field9',width:100,title: ''}, 
                      {columnid:'field10',width:100,title: ''}, 
                      {columnid:'field11',width:100,title: ''}, 
                      {columnid:'field12',width:100,title: ''}, 
                      {columnid:'field13',width:100,title: ''}, 
                      {columnid:'field14',width:100,title: ''}, 
                      {columnid:'field15',width:100,title: ''}, 
                      {columnid:'field16',width:100,title: ''}, 
                      {columnid:'field17',width:100,title: ''}, 
                      {columnid:'field18',width:100,title: ''}, 
                      {columnid:'field19',width:100,title: ''}, 
                      {columnid:'field20',width:100,title: ''}, 
                      
                      ],
                  /*header*/
                
                  column: {  
                      style:{
                          Alignment:{
                              Horizontal:"Center",
                              Vertical:"Center",  
                              WrapText:1
                              
                          },
                          Font:{
                              Bold:"1",
                              Color:"#000000",
                              Size:10
                          },
                          
                          Interior:{
                              Color:"#7CEECE",
                              Pattern:"Solid"
                          }
                      }},
                cells: {    
                      0:{
                          0:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid",
                                      },
                              Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",
                                WrapText: 1,
                                  },  
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                              },                        
                              }  
                          },
                          1:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                          },  
                              Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                  }
                          },
                          2:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      }, 
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          }                
                                  }
                              },
                          3:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },            
                                    
                                  }
                              },
                          4:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              },
                          5:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              }, 
                          6:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                             
                              }
                              },
                          7:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },              
                                  }
                              },
                          8:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1,
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },              
                                    }
                                },   
                            9:{style:{
                                      Interior:{ 
                                          Color:"#95a5a6",
                                          Pattern:"Solid"
                                                  },
                                      Alignment:{
                                          Horizontal: 'Center', 
                                          Vertical: 'Center',
                                          WrapText: 1,
                                              },
                                      Font:{
                                          Size:10,
                                          Bold:"1",
                                          Color:"#000000",
                                  },              
                                          }
                                      },              
                              10:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1,
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                                },              
                                    }
                                },              
                                11:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                              },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1,
                                          },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                                  },              
                                      }
                                  },              
                                  12:{style:{
                                    Interior:{ 
                                        Color:"#95a5a6",
                                        Pattern:"Solid"
                                                },
                                    Alignment:{
                                        Horizontal: 'Center', 
                                        Vertical: 'Center',
                                        WrapText: 1,
                                            },
                                    Font:{
                                        Size:10,
                                        Bold:"1",
                                        Color:"#000000",
                                    },              
                                        }
                                    },                   
                                    13:{style:{
                                      Interior:{ 
                                          Color:"#95a5a6",
                                          Pattern:"Solid"
                                                  },
                                      Alignment:{
                                          Horizontal: 'Center', 
                                          Vertical: 'Center',
                                          WrapText: 1,
                                              },
                                      Font:{
                                          Size:10,
                                          Bold:"1",
                                          Color:"#000000",
                                      },              
                                          }
                                      },              
                                      14:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                    },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1,
                                                },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                        },              
                                            }
                                        },               
                                        15:{style:{
                                          Interior:{ 
                                              Color:"#95a5a6",
                                              Pattern:"Solid"
                                                      },
                                          Alignment:{
                                              Horizontal: 'Center', 
                                              Vertical: 'Center',
                                              WrapText: 1,
                                                  },
                                          Font:{
                                              Size:10,
                                              Bold:"1",
                                              Color:"#000000",
                                          },              
                                              }
                                          },            
                                          16:{style:{
                                            Interior:{ 
                                                Color:"#95a5a6",
                                                Pattern:"Solid"
                                                        },
                                            Alignment:{
                                                Horizontal: 'Center', 
                                                Vertical: 'Center',
                                                WrapText: 1,
                                                    },
                                            Font:{
                                                Size:10,
                                                Bold:"1",
                                                Color:"#000000",
                                            },              
                                                }
                                            },            
                                            17:{style:{
                                              Interior:{ 
                                                  Color:"#95a5a6",
                                                  Pattern:"Solid"
                                                          },
                                              Alignment:{
                                                  Horizontal: 'Center', 
                                                  Vertical: 'Center',
                                                  WrapText: 1,
                                                      },
                                              Font:{
                                                  Size:10,
                                                  Bold:"1",
                                                  Color:"#000000",
                                              },              
                                                  }
                                              },            
                                              18:{style:{
                                                Interior:{ 
                                                    Color:"#95a5a6",
                                                    Pattern:"Solid"
                                                            },
                                                Alignment:{
                                                    Horizontal: 'Center', 
                                                    Vertical: 'Center',
                                                    WrapText: 1,
                                                        },
                                                Font:{
                                                    Size:10,
                                                    Bold:"1",
                                                    Color:"#000000",
                                                },              
                                                    }
                                                },            
                                                19:{style:{
                                                  Interior:{ 
                                                      Color:"#95a5a6",
                                                      Pattern:"Solid"
                                                              },
                                                  Alignment:{
                                                      Horizontal: 'Center', 
                                                      Vertical: 'Center',
                                                      WrapText: 1,
                                                          },
                                                  Font:{
                                                      Size:10,
                                                      Bold:"1",
                                                      Color:"#000000",
                                                  },              
                                                      }
                                                  },
                      }   
                },
          };
          this.showExportButton = true;
          alasql.promise('SELECT * INTO XLSXML("ProductosEtiquetados_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
          .then(function(data){
              console.log('Data saved');
          }).catch(function(err){
              console.log('Error:', err);
          });
        });
  }

  selectImage(src){
    window.scroll(0,0);
    this.selectedImage = src;
  }
  unselectImage(){
    this.selectedImage = null;
  }

  printTags(selectedlabeledProduct){
    this.selectedlabeledProduct = selectedlabeledProduct;
    if (this.selectedlabeledProduct.barcode){
      setTimeout( ()=>{
          JsBarcode("#barcode",this.selectedlabeledProduct.barcode,{format: "CODE128",width:7,fontSize: 50,textMargin:-12,margin:0, height: 70});
          this.selectedlabeledProduct.barcode_img = document.getElementById('barcode-div').getElementsByTagName('img')[0].src;
          setTimeout( ()=>{
            document.getElementById("ticket").classList.remove('hide')
            window.print();
            document.getElementById("ticket").classList.add('hide')
          },0);
      },0);
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/labeledproducts/components/list-labeledproduct-report/list-labeledproduct-report.component.ts